import React from "react";
import { getPublisherAvatarUrl } from "../../utils";
import { PostDetailBadgeCheckIcon } from "../PostDetail/PostDetailCommentIcons";
import { stripAnalystBio } from "./analystUtils";
import { AnalystsArrowRightIcon, AnalystsSparklesIcon } from "./AnalystsIcons";
import {
  AnalystAvatarWrap,
  AnalystBio,
  AnalystCardLink,
  AnalystCardTopAccent,
  AnalystCta,
  AnalystCtaDivider,
  AnalystFeaturedBadge,
  AnalystName,
  AnalystNameRow,
  AnalystRole,
  AnalystVerifiedIcon,
} from "./Analysts.styles";

const AnalystCard = ({ publisher }) => {
  const bio = stripAnalystBio(publisher.bio);
  const isFeatured = publisher.isFeaturedContributor;

  return (
    <AnalystCardLink
      to={`/analyst/${publisher.slug}`}
      aria-label={`View ${publisher.name}'s profile`}
    >
      <AnalystCardTopAccent aria-hidden="true" />

      {isFeatured && (
        <AnalystFeaturedBadge>
          <AnalystsSparklesIcon />
          Featured contributor
        </AnalystFeaturedBadge>
      )}

      <AnalystAvatarWrap>
        <img
          src={getPublisherAvatarUrl(publisher)}
          alt={publisher.name}
          width={112}
          height={112}
          loading="lazy"
          decoding="async"
        />
      </AnalystAvatarWrap>

      <AnalystNameRow>
        <AnalystName>{publisher.name}</AnalystName>
        <AnalystVerifiedIcon aria-label="Verified analyst">
          <PostDetailBadgeCheckIcon />
        </AnalystVerifiedIcon>
      </AnalystNameRow>

      <AnalystRole>{publisher.title || "Market analyst"}</AnalystRole>

      {bio ? <AnalystBio>{bio}</AnalystBio> : <AnalystBio aria-hidden="true">&nbsp;</AnalystBio>}

      <AnalystCtaDivider aria-hidden="true" />
      <AnalystCta aria-hidden="true">
        View profile
        <AnalystsArrowRightIcon />
      </AnalystCta>
    </AnalystCardLink>
  );
};

export default AnalystCard;
